export class TalentMessengerKeys{
   static  TalentCandiate = "talentcand";
}